__webpack_require__.p = "/bn/invest/funds/";